// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chartSection_store {
    border-radius: var(--border-radius);
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.03);
    background-color: #ffffff;
    background-clip: border-box;
    border: 1px solid #f3f3f3;
    margin-top: 30px;
}

.chartSection_store .chartBlock {
    width: 48%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}

.chartDropDown {
    position: absolute;
    right: 30px;
    top: 20px;
}

.productTable {
    margin-top: 10px;
    padding-left: 35px;
    padding-right: 35px;
}

.productTable .tableWrapper {
    padding: 10px 0;
}


.pieChartWrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 0;
}

.pieChartWrapper p {
    padding: 5px;
    text-align: initial;
}

.chartWrapperColumn {
    display: flex;
    flex-direction: column;
}

.lineChartCustomers {
    padding: 16px 0 16px 0;
}

.productTable .tableWrapper {
    margin-top: 10px;
}

.orderStatusCardWrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 30px;
}

.orderStatusCardWrapper .orderchartSection {
    border-radius: var(--border-radius);
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.03);
    background-color: #ffffff;
    background-clip: border-box;
    border: 1px solid #f3f3f3;
    height: 100px;
    width: 20%;
}

.orderStatusIcon i {
    font-size: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #ced4da;
    border-radius: 61%;
    width: 60px;
    color: #8f8f8f;
    font-weight: 400;
}

.orderchartBlock {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px;
}

.orderStatusText p {
    margin-top: 5px;
}

.orderStatusText {
    margin-left: 5px;
}


.productTable thead th {
    width: 40%;
}

.productTable span {
    display: flex;
    justify-content: start;
    align-items: initial;
    font-size: 15px;
    font-weight: 500
}

.productTable {
    margin-top: 10px;
    width: 100%;
}


.individualPieChartBlock {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.product_not_found {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: initial;
    padding: 30px;
}

.top_five_categories_heading {
    margin-left: 35px;
    display: flex;
    justify-content: start;
    align-items: initial;
    font-size: 15px;
    font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/Components/Dashboard/StoreAdminDashboard/StoreAdminDashboard.css"],"names":[],"mappings":"AAAA;IACI,mCAAmC;IACnC,0CAA0C;IAC1C,yBAAyB;IACzB,2BAA2B;IAC3B,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;;AAGA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,mCAAmC;IACnC,0CAA0C;IAC1C,yBAAyB;IACzB,2BAA2B;IAC3B,yBAAyB;IACzB,aAAa;IACb,UAAU;AACd;;AAEA;IACI,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;;AAGA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,eAAe;IACf;AACJ;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;;AAGA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,oBAAoB;IACpB,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;AACpB","sourcesContent":[".chartSection_store {\n    border-radius: var(--border-radius);\n    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.03);\n    background-color: #ffffff;\n    background-clip: border-box;\n    border: 1px solid #f3f3f3;\n    margin-top: 30px;\n}\n\n.chartSection_store .chartBlock {\n    width: 48%;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n}\n\n.chartDropDown {\n    position: absolute;\n    right: 30px;\n    top: 20px;\n}\n\n.productTable {\n    margin-top: 10px;\n    padding-left: 35px;\n    padding-right: 35px;\n}\n\n.productTable .tableWrapper {\n    padding: 10px 0;\n}\n\n\n.pieChartWrapper {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 0;\n}\n\n.pieChartWrapper p {\n    padding: 5px;\n    text-align: initial;\n}\n\n.chartWrapperColumn {\n    display: flex;\n    flex-direction: column;\n}\n\n.lineChartCustomers {\n    padding: 16px 0 16px 0;\n}\n\n.productTable .tableWrapper {\n    margin-top: 10px;\n}\n\n.orderStatusCardWrapper {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-top: 30px;\n}\n\n.orderStatusCardWrapper .orderchartSection {\n    border-radius: var(--border-radius);\n    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.03);\n    background-color: #ffffff;\n    background-clip: border-box;\n    border: 1px solid #f3f3f3;\n    height: 100px;\n    width: 20%;\n}\n\n.orderStatusIcon i {\n    font-size: 40px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border: 1px solid #ced4da;\n    border-radius: 61%;\n    width: 60px;\n    color: #8f8f8f;\n    font-weight: 400;\n}\n\n.orderchartBlock {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 15px;\n}\n\n.orderStatusText p {\n    margin-top: 5px;\n}\n\n.orderStatusText {\n    margin-left: 5px;\n}\n\n\n.productTable thead th {\n    width: 40%;\n}\n\n.productTable span {\n    display: flex;\n    justify-content: start;\n    align-items: initial;\n    font-size: 15px;\n    font-weight: 500\n}\n\n.productTable {\n    margin-top: 10px;\n    width: 100%;\n}\n\n\n.individualPieChartBlock {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n}\n\n.product_not_found {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: initial;\n    padding: 30px;\n}\n\n.top_five_categories_heading {\n    margin-left: 35px;\n    display: flex;\n    justify-content: start;\n    align-items: initial;\n    font-size: 15px;\n    font-weight: 500;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
